/* eslint-disable */
import * as Types from './generated-types';

import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  languageCode
  code
  name
  enabled
  customFields
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  createdAt
  updatedAt
  fullName
  streetLine1
  streetLine2
  city
  province
  postalCode
  country {
    ...Country
  }
  customFields
}
    `;
export const CompanyAddressFragmentDoc = gql`
    fragment CompanyAddress on CompanyAddress {
  id
  fullName
  streetLine1
  streetLine2
  province
  countryCode
  city
  postalCode
  phoneNumber
  defaultBillingAddress
  defaultShippingAddress
  customFields {
    erpId
  }
}
    `;
export const BreadcrumbFragmentDoc = gql`
    fragment Breadcrumb on CollectionBreadcrumb {
  name
  id
  slug
}
    `;
export const ActiveOrderFragmentDoc = gql`
    fragment ActiveOrder on Order {
  id
  state
  updatedAt
  createdAt
  total
  totalWithTax
  subTotal
  subTotalWithTax
  shipping
  currencyCode
  shippingWithTax
  totalQuantity
  lines {
    id
    linePrice
    discountedLinePrice
    unitPrice
    quantity
    productVariant {
      currencyCode
      id
      name
      sku
      price
      assets {
        id
        source
      }
    }
  }
}
    `;
export const OrderAddressFragmentDoc = gql`
    fragment OrderAddress on OrderAddress {
  fullName
  company
  streetLine1
  streetLine2
  city
  province
  postalCode
  country
  countryCode
  phoneNumber
  customFields
}
    `;
export const ProductVariantCustomFieldFragmentDoc = gql`
    fragment ProductVariantCustomField on ProductVariantCustomFields {
  productDetailName @include(if: $isPreRender)
  infoText @include(if: $isPreRender)
  systemName
  customAttributes @include(if: $isPreRender) {
    itemText
    itemHeadline
  }
  onSiteImages @skip(if: $isPreRender) {
    name
    source
  }
  systemInformationItems @skip(if: $isPreRender) {
    itemText
    itemHeadline
  }
  additionalProducts @skip(if: $isPreRender) {
    id
    name
  }
}
    `;
export const AssetFragmentDoc = gql`
    fragment Asset on Asset {
  width
  height
  source
}
    `;
export const ProductVariantFragmentDoc = gql`
    fragment ProductVariant on ProductVariant {
  id
  name
  sku
  stockLevel
  currencyCode
  price
  options {
    code
    group {
      name
    }
  }
  facetValues {
    id
    code
    name
  }
  customFields @include(if: $withCustomFields) {
    pimcoreId
    ...ProductVariantCustomField
  }
  assets {
    ...Asset
  }
}
    `;
export const CustomerDataFragmentDoc = gql`
    fragment CustomerData on Customer {
  id
  firstName
  lastName
  emailAddress
  title
  phoneNumber
  customFields @include(if: $withCustomFields) {
    salutation
  }
}
    `;
export const OfferPriceFragmentDoc = gql`
    fragment OfferPrice on OfferPrice {
  id
  price
  currencyCode
  productVariant {
    name
    price
    product {
      name
    }
    id
    sku
    featuredAsset {
      ...Asset
    }
    customFields {
      systemName
    }
  }
}
    `;
export const OfferFragmentFragmentDoc = gql`
    fragment OfferFragment on Offer {
  id
  reference
  status
  createdAt
  number
  date
  address
  subject
  headerText
  footerText
  termsOfDelivery
  termsOfPayment
  additionalDiscount
  customOfferLines {
    id
    name
    price
    quantity
    taxRate
    discount
    positionTotal
    alternative
  }
  order {
    id
    totalWithTax
    total
    subTotal
    subTotalWithTax
    lines {
      customFields {
        offerOrderLine {
          price
          positionTotal
        }
      }
    }
  }
}
    `;
 const AddItemToOrderDocument = gql`
    mutation AddItemToOrder($productVariantId: ID!, $quantity: Int!, $withCustomFields: Boolean = false) {
  addItemToOrder(productVariantId: $productVariantId, quantity: $quantity) {
    __typename
    ... on Order {
      id
      customer {
        ...CustomerData
      }
      state
    }
    ... on OrderModificationError {
      errorCode
      message
      __typename
    }
    ... on OrderLimitError {
      message
      maxItems
      __typename
    }
    ... on NegativeQuantityError {
      errorCode
      message
      __typename
    }
    ... on InsufficientStockError {
      errorCode
      message
      quantityAvailable
      __typename
    }
  }
}
    ${CustomerDataFragmentDoc}`;
 const AddItemToOrderBySkuDocument = gql`
    mutation addItemToOrderBySku($input: AddItemToOrderBySkuInput!) {
  addItemToOrderBySku(input: $input) {
    ... on Order {
      id
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on Node {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const AddPaymentDocument = gql`
    mutation AddPayment($input: PaymentInput!) {
  addPaymentToOrder(input: $input) {
    __typename
    ...ActiveOrder
    ... on Order {
      id
      code
    }
    ... on OrderPaymentStateError {
      errorCode
      message
    }
    ... on IneligiblePaymentMethodError {
      errorCode
      message
    }
    ... on PaymentFailedError {
      errorCode
      message
    }
    ... on PaymentDeclinedError {
      errorCode
      message
      paymentErrorMessage
    }
    ... on OrderStateTransitionError {
      errorCode
      message
      transitionError
      fromState
      toState
    }
    ... on NoActiveOrderError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    ${ActiveOrderFragmentDoc}`;
 const AddToWishlistDocument = gql`
    mutation AddToWishlist($productVariantId: ID!, $wishlistId: ID) {
  addToWishlist(productVariantId: $productVariantId, wishlistId: $wishlistId) {
    id
    itemCount
    items {
      id
    }
  }
}
    `;
 const UpdateCompanyAddressDocument = gql`
    mutation UpdateCompanyAddress($input: UpdateCompanyAddressInput!) {
  updateCompanyAddress(address: $input) {
    __typename
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on CompanyAddress {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on Node {
      id
    }
  }
}
    `;
 const DeleteCompanyAddressDocument = gql`
    mutation DeleteCompanyAddress($id: ID!) {
  deleteCompanyAddress(addressId: $id) {
    __typename
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on Success {
      success
    }
  }
}
    `;
 const CreateCompanyAddressDocument = gql`
    mutation CreateCompanyAddress($input: CreateCompanyAddressInput!) {
  addCompanyAddress(address: $input) {
    __typename
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on CompanyAddress {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on Node {
      id
    }
  }
}
    `;
 const AdjustOrderLineDocument = gql`
    mutation AdjustOrderLine($orderLineId: ID!, $quantity: Int!) {
  adjustOrderLine(orderLineId: $orderLineId, quantity: $quantity) {
    ... on Order {
      id
      totalQuantity
      lines {
        quantity
      }
    }
    ... on OrderModificationError {
      errorCode
      message
    }
    ... on OrderLimitError {
      errorCode
      message
    }
    ... on NegativeQuantityError {
      errorCode
      message
    }
    ... on InsufficientStockError {
      errorCode
      message
      quantityAvailable
    }
  }
}
    `;
 const ApplyCouponCodeDocument = gql`
    mutation ApplyCouponCode($couponCode: String!) {
  applyCouponCode(couponCode: $couponCode) {
    ... on Order {
      id
    }
    ... on CouponCodeExpiredError {
      errorCode
      message
      couponCode
    }
    ... on CouponCodeInvalidError {
      errorCode
      message
      couponCode
    }
    ... on CouponCodeLimitError {
      errorCode
      message
      couponCode
      limit
    }
    ... on Node {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const CreateAddressDocument = gql`
    mutation CreateAddress($city: String!, $company: String!, $countryCode: String!, $fullName: String!, $postalCode: String!, $province: String!, $streetLine1: String!, $streetLine2: String!, $phoneNumber: String!) {
  createCustomerAddress(
    input: {city: $city, company: $company, countryCode: $countryCode, fullName: $fullName, postalCode: $postalCode, province: $province, streetLine1: $streetLine1, streetLine2: $streetLine2, phoneNumber: $phoneNumber}
  ) {
    id
  }
}
    `;
 const CreateAssetDocument = gql`
    mutation CreateAsset($input: [CreateAssetInput!]!) {
  createAssets(input: $input) {
    __typename
    ... on Asset {
      id
      preview
      source
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on MimeTypeError {
      errorCode
      message
      mimeType
    }
  }
}
    `;
 const CreateCustomerAddressDocument = gql`
    mutation createCustomerAddress($input: CreateAddressInput!) {
  createCustomerAddress(input: $input) {
    id
    createdAt
  }
}
    `;
 const CreateOfferDocument = gql`
    mutation CreateOffer($address: String!, $subject: String!, $headerText: String!, $footerText: String!, $reference: String!, $positions: [CreateOfferPositionInput!], $termsOfDelivery: String!, $termsOfPayment: String!, $date: DateTime!, $number: String!, $additionalDiscount: Int) {
  createOffer(
    input: {address: $address, subject: $subject, headerText: $headerText, footerText: $footerText, reference: $reference, positions: $positions, termsOfPayment: $termsOfPayment, termsOfDelivery: $termsOfDelivery, date: $date, number: $number, additionalDiscount: $additionalDiscount}
  ) {
    __typename
    ... on Offer {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const CreateWishlistDocument = gql`
    mutation CreateWishlist($name: String!, $description: String) {
  createWishlist(input: {name: $name, description: $description}) {
    id
    name
  }
}
    `;
 const DeleteOfferDocument = gql`
    mutation DeleteOffer($id: ID!) {
  deleteOffer(offerId: $id) {
    __typename
    ... on Success {
      success
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on NotAllowedError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const DeleteWishlistDocument = gql`
    mutation DeleteWishlist($id: ID!) {
  deleteWishlist(id: $id) {
    result
    message
  }
}
    `;
 const LoginUserDocument = gql`
    mutation LoginUser($username: String!, $password: String!, $rememberMe: Boolean!) {
  login(username: $username, password: $password, rememberMe: $rememberMe) {
    __typename
    ... on CurrentUser {
      id
      identifier
    }
    ... on InvalidCredentialsError {
      errorCode
      message
    }
    ... on NotVerifiedError {
      errorCode
      message
    }
    ... on NativeAuthStrategyError {
      errorCode
      message
    }
  }
}
    `;
 const LogoutUserDocument = gql`
    mutation LogoutUser {
  logout {
    success
    __typename
  }
}
    `;
 const SubscribeToNewsletterDocument = gql`
    mutation SubscribeToNewsletter($input: NewsletterAddressInput!) {
  subscribeToNewsletter(input: $input) {
    success
  }
}
    `;
 const UnsubscribeToNewsletterDocument = gql`
    mutation UnsubscribeToNewsletter($input: NewsletterAddressInput!) {
  unsubscribeToNewsletter(input: $input) {
    success
  }
}
    `;
 const CreateOfferPriceDocument = gql`
    mutation CreateOfferPrice($productVariantId: ID!, $offerPrice: Int!, $currencyCode: String!) {
  createOfferPrice(
    input: {productVariantId: $productVariantId, price: $offerPrice, currencyCode: $currencyCode}
  ) {
    ... on OfferPrice {
      id
      price
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
  }
}
    `;
 const UpdateOfferPriceDocument = gql`
    mutation UpdateOfferPrice($id: ID!, $price: Int!) {
  updateOfferPrice(input: {offerPriceId: $id, price: $price}) {
    __typename
    ... on OfferPrice {
      id
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const DeleteOfferPriceDocument = gql`
    mutation DeleteOfferPrice($id: ID!) {
  deleteOfferPrice(offerPriceId: $id) {
    __typename
    ... on Success {
      success
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const CreateOfferPricesDocument = gql`
    mutation CreateOfferPrices($input: [CreateOfferPriceInput!]!) {
  createOfferPrices(input: $input) {
    __typename
    ... on OfferPriceList {
      totalItems
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const PasswordResetDocument = gql`
    mutation PasswordReset($password: String!, $token: String!) {
  resetPassword(password: $password, token: $token) {
    ... on CurrentUser {
      __typename
      id
    }
    ... on ErrorResult {
      __typename
      errorCode
      message
    }
    ... on NotVerifiedError {
      __typename
      errorCode
      message
    }
    ... on PasswordResetTokenExpiredError {
      __typename
      errorCode
      message
    }
    ... on PasswordResetTokenInvalidError {
      __typename
      errorCode
      message
    }
    ... on PasswordValidationError {
      __typename
      errorCode
      message
      validationErrorMessage
    }
  }
}
    `;
 const RegisterDocument = gql`
    mutation Register($input: B2BRegisterInput!) {
  registerB2BCustomer(input: $input) {
    __typename
    ... on Success {
      success
    }
    ... on MissingPasswordError {
      errorCode
      message
    }
    ... on PasswordValidationError {
      errorCode
      message
    }
    ... on NativeAuthStrategyError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on InvalidVatError {
      errorCode
      message
    }
  }
}
    `;
 const RemoveAllOrderLinesDocument = gql`
    mutation RemoveAllOrderLines {
  removeAllOrderLines {
    __typename
    ... on Order {
      id
    }
    ... on OrderModificationError {
      message
    }
  }
}
    `;
 const RemoveAllOrderLinesAndStockMovementsDocument = gql`
    mutation removeAllOrderLinesAndStockMovements {
  removeAllOrderLinesAndStockMovements {
    __typename
    ... on Order {
      id
    }
    ... on OrderModificationError {
      errorCode
      message
    }
    ... on Node {
      id
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const RemoveCouponCodeDocument = gql`
    mutation RemoveCouponCode($couponCode: String!) {
  removeCouponCode(couponCode: $couponCode) {
    code
    ... on Order {
      id
    }
  }
}
    `;
 const RemoveFromWishlistDocument = gql`
    mutation RemoveFromWishlist($itemIds: [ID!]!, $wishlistId: ID!) {
  removeFromWishlist(itemIds: $itemIds, wishlistId: $wishlistId) {
    id
    name
  }
}
    `;
 const RemoveItemFromOrderDocument = gql`
    mutation RemoveItemFromOrder($orderLineID: ID!) {
  removeOrderLine(orderLineId: $orderLineID) {
    ... on Order {
      id
    }
    ... on OrderModificationError {
      errorCode
      message
    }
  }
}
    `;
 const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(emailAddress: $email) {
    ... on Success {
      __typename
      success
    }
    ... on ErrorResult {
      __typename
      errorCode
      message
    }
    ... on NativeAuthStrategyError {
      __typename
      errorCode
      message
    }
  }
}
    `;
 const SetActiveCompanyDocument = gql`
    mutation SetActiveCompany($companyId: ID!) {
  setActiveCompany(companyId: $companyId) {
    ... on NotAllowedError {
      errorCode
      message
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on Customer {
      id
      firstName
      lastName
    }
  }
}
    `;
 const SetShippingAddressDocument = gql`
    mutation SetShippingAddress($input: CreateAddressInput!) {
  setOrderShippingAddress(input: $input) {
    ...ActiveOrder
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    ${ActiveOrderFragmentDoc}`;
 const SetBillingAddressDocument = gql`
    mutation SetBillingAddress($input: CreateAddressInput!) {
  setOrderBillingAddress(input: $input) {
    ...ActiveOrder
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    ${ActiveOrderFragmentDoc}`;
 const SetOrderCustomFieldsDocument = gql`
    mutation SetOrderCustomFields($comment: String, $reference: String, $commission: String) {
  setOrderCustomFields(
    input: {customFields: {comment: $comment, reference: $reference, commission: $commission}}
  ) {
    ... on Order {
      id
    }
    ... on NoActiveOrderError {
      errorCode
      message
    }
  }
}
    `;
 const SetOrderShippingMethodDocument = gql`
    mutation SetOrderShippingMethod($shippingMethodId: [ID!]!) {
  setOrderShippingMethod(shippingMethodId: $shippingMethodId) {
    ...ActiveOrder
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    ${ActiveOrderFragmentDoc}`;
 const ToogleCustomerSpecificPriceDocument = gql`
    mutation ToogleCustomerSpecificPrice {
  toggleCustomerSpecificPrices {
    ... on Order {
      id
      total
      lines {
        quantity
        unitPrice
        productVariant {
          price
          id
        }
      }
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const TransformOfferToCartDocument = gql`
    mutation transformOfferToCart($offerId: ID!) {
  transformOfferToCart(offerId: $offerId) {
    __typename
    ... on Success {
      success
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const TransitionOrderDocument = gql`
    mutation TransitionOrder($state: String!) {
  transitionOrderToState(state: $state) {
    ...ActiveOrder
    ... on ErrorResult {
      errorCode
      message
    }
    ... on OrderStateTransitionError {
      errorCode
      message
      transitionError
      fromState
      toState
    }
  }
}
    ${ActiveOrderFragmentDoc}`;
 const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($title: String, $firstName: String!, $lastName: String!, $phoneNumber: String, $salutation: String) {
  updateCustomer(
    input: {title: $title, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, customFields: {salutation: $salutation}}
  ) {
    id
  }
}
    `;
 const UpdateCustomerPasswordDocument = gql`
    mutation UpdateCustomerPassword($currentPassword: String!, $newPassword: String!) {
  updateCustomerPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
  ) {
    __typename
    ... on Success {
      success
    }
    ... on InvalidCredentialsError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on NativeAuthStrategyError {
      errorCode
      message
    }
    ... on PasswordValidationError {
      errorCode
      message
    }
  }
}
    `;
 const RequestUpdateCustomerEmailDocument = gql`
    mutation RequestUpdateCustomerEmail($password: String!, $newEmailAddress: String!) {
  requestUpdateCustomerEmailAddress(
    password: $password
    newEmailAddress: $newEmailAddress
  ) {
    __typename
    ... on Success {
      success
    }
    ... on InvalidCredentialsError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
    ... on NativeAuthStrategyError {
      errorCode
      message
    }
    ... on EmailAddressConflictError {
      errorCode
      message
    }
  }
}
    `;
 const UpdateOfferDocument = gql`
    mutation UpdateOffer($id: ID!, $address: String, $subject: String, $headerText: String, $footerText: String, $reference: String, $positions: [CreateOfferPositionInput!], $termsOfDelivery: String, $termsOfPayment: String, $date: DateTime, $number: String, $status: OfferStatus, $additionalDiscount: Int) {
  updateOffer(
    input: {id: $id, address: $address, subject: $subject, headerText: $headerText, footerText: $footerText, reference: $reference, positions: $positions, termsOfPayment: $termsOfPayment, termsOfDelivery: $termsOfDelivery, date: $date, number: $number, status: $status, additionalDiscount: $additionalDiscount}
  ) {
    __typename
    ... on Offer {
      id
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on NotAllowedError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const UpdateOfferSettingsDocument = gql`
    mutation UpdateOfferSettings($color: String, $vat: String, $iban: String, $accountNumber: String, $bankName: String, $bankCode: String, $address: String, $email: String, $phoneNumber: String, $companyRegister: String, $logo: String) {
  updateOfferSettings(
    input: {color: $color, vat: $vat, iban: $iban, accountNumber: $accountNumber, bankName: $bankName, bankCode: $bankCode, address: $address, email: $email, phoneNumber: $phoneNumber, companyRegister: $companyRegister, logo: $logo}
  ) {
    __typename
    ... on OfferSettings {
      id
    }
    ... on EntityNotFoundError {
      errorCode
      message
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
    `;
 const UpdateWishlistDocument = gql`
    mutation UpdateWishlist($id: ID!, $name: String!, $description: String) {
  updateWishlist(input: {id: $id, name: $name, description: $description}) {
    id
  }
}
    `;
 const ActiveChannelDocument = gql`
    query ActiveChannel {
  activeChannel {
    id
    code
    currencyCode
    pricesIncludeTax
    token
    defaultLanguageCode
    defaultShippingZone {
      id
      name
      members {
        id
        name
      }
    }
  }
}
    `;
 const ActiveCompanyDocument = gql`
    query ActiveCompany {
  activeCompany {
    id
    name
    customFields {
      erpId
      vat
      ust
      isConfiguratorAdmin
    }
    termsOfPayment {
      paymentId
      contactPerson
      text
      amount
    }
    discounts {
      id
      discountType
      discountGroup
      discountType2
      customFields {
        erpId
      }
      customerDiscountPercentages {
        id
        value
        index
      }
    }
  }
}
    `;
 const ActiveCompanyAddressesDocument = gql`
    query ActiveCompanyAddresses {
  activeCompany {
    addresses {
      ...CompanyAddress
    }
  }
}
    ${CompanyAddressFragmentDoc}`;
 const ContactPersonIdDocument = gql`
    query ContactPersonId {
  activeCompany {
    termsOfPayment {
      contactPerson
    }
  }
}
    `;
 const ActiveCustomerDocument = gql`
    query ActiveCustomer($withCustomFields: Boolean = false) {
  activeCustomer {
    ...CustomerData
  }
}
    ${CustomerDataFragmentDoc}`;
 const ActiveCustomerRolesDocument = gql`
    query ActiveCustomerRoles {
  activeCustomer {
    groups {
      id
      name
    }
    customFields {
      useCSP
    }
  }
}
    `;
 const ActiveCustomerForCheckoutDocument = gql`
    query ActiveCustomerForCheckout {
  activeCustomer {
    firstName
    lastName
    addresses {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}
${CountryFragmentDoc}`;
 const ActiveCustomerOrdersDocument = gql`
    query ActiveCustomerOrders {
  activeCustomer {
    orders {
      items {
        id
        code
        state
        total
        currencyCode
        orderPlacedAt
        customFields {
          erpId
        }
      }
    }
  }
}
    `;
 const ActiveOrderCartDocument = gql`
    query ActiveOrderCart {
  activeOrder {
    state
    subTotal
    shipping
    total
    totalWithTax
    currencyCode
    subTotalWithTax
    shippingWithTax
    totalQuantity
    promotions {
      id
      name
      couponCode
    }
    couponCodes
    discounts {
      amount
      description
    }
    taxSummary {
      taxRate
      taxBase
      taxTotal
    }
    lines {
      id
      discountedLinePrice
      productVariant {
        id
        currencyCode
        price
        assets {
          source
        }
        facetValues {
          id
          name
          facet {
            name
          }
        }
        options {
          code
          group {
            name
          }
        }
        name
        sku
        product {
          name
          slug
        }
        customFields {
          systemName
        }
      }
      unitPrice
      linePrice
      quantity
    }
    customer {
      id
      customFields {
        erpId
        company {
          customFields {
            erpId
          }
        }
      }
    }
  }
}
    `;
 const ActiveOrderCheckoutDocument = gql`
    query ActiveOrderCheckout {
  activeOrder {
    id
    state
    updatedAt
    createdAt
    total
    totalWithTax
    subTotal
    subTotalWithTax
    shipping
    currencyCode
    shippingWithTax
    totalQuantity
    promotions {
      id
      name
      couponCode
    }
    couponCodes
    discounts {
      amount
      description
    }
    taxSummary {
      taxRate
      taxBase
      taxTotal
    }
    shippingAddress {
      ...OrderAddress
    }
    billingAddress {
      ...OrderAddress
    }
    shippingLines {
      shippingMethod {
        id
        languageCode
        code
        name
        description
      }
    }
    lines {
      id
      linePrice
      discountedLinePrice
      unitPrice
      quantity
      productVariant {
        currencyCode
        id
        name
        sku
        price
        product {
          id
          name
          slug
        }
        facetValues {
          id
          name
          facet {
            name
          }
        }
        sku
        assets {
          id
          source
        }
      }
    }
  }
}
    ${OrderAddressFragmentDoc}`;
 const ActiveOrderNavigationDocument = gql`
    query ActiveOrderNavigation {
  activeOrder {
    lines {
      quantity
    }
  }
}
    `;
 const ActiveOrderOfferDocument = gql`
    query ActiveOrderOffer {
  activeOrder {
    id
  }
}
    `;
 const ActiveUserWishlistDocument = gql`
    query ActiveUserWishlist($id: ID!) {
  activeUserWishlist(id: $id) {
    id
    itemCount
    name
    createdAt
    items {
      id
      product {
        id
        name
        slug
        featuredAsset {
          source
        }
      }
      productVariant {
        id
        sku
        name
        price
        priceWithTax
        stockLevel
        customFields {
          systemName
        }
      }
      purchased
      lastPurchasedAt
    }
    description
    isPublic
    publicCode
  }
}
    `;
 const ActiveUserWishlistsDocument = gql`
    query ActiveUserWishlists {
  activeUserWishlists {
    id
    itemCount
    name
    createdAt
    items {
      id
      product {
        id
        name
        slug
      }
      productVariant {
        id
        sku
        name
        price
        priceWithTax
        stockLevel
      }
      purchased
      lastPurchasedAt
    }
    description
    isPublic
    publicCode
  }
}
    `;
 const AllCollectionsDocument = gql`
    query AllCollections {
  collections {
    items {
      breadcrumbs {
        ...Breadcrumb
      }
      slug
    }
  }
}
    ${BreadcrumbFragmentDoc}`;
 const AvailableCompaniesDocument = gql`
    query AvailableCompanies {
  companies {
    items {
      id
      name
      customFields {
        erpId
        vat
        ust
      }
      addresses {
        fullName
        streetLine1
      }
    }
  }
}
    `;
 const AvailableCountriesDocument = gql`
    query AvailableCountries {
  availableCountries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
 const CollectionDocument = gql`
    query Collection($slug: String) {
  collection(slug: $slug) {
    id
    slug
    customFields {
      seoDescription
      hasDetailPage
      preselectedDiameter
    }
    breadcrumbs {
      ...Breadcrumb
    }
    name
    description
    assets {
      ...Asset
    }
  }
}
    ${BreadcrumbFragmentDoc}
${AssetFragmentDoc}`;
 const CustomerSpecificPriceDocument = gql`
    query CustomerSpecificPrice($channelCode: String!, $variantId: String!) {
  customerSpecificPrice(channelCode: $channelCode, variantId: $variantId) {
    basePrice
    price
  }
}
    `;
 const EligiblePaymentMethodsDocument = gql`
    query EligiblePaymentMethods {
  eligiblePaymentMethods {
    id
    code
    name
    description
    isEligible
    eligibilityMessage
    customFields
  }
}
    `;
 const EligibleShippingMethodsDocument = gql`
    query EligibleShippingMethods {
  eligibleShippingMethods {
    id
    price
    priceWithTax
    code
    name
    description
    metadata
    customFields
  }
}
    `;
 const NextOrderStatesDocument = gql`
    query NextOrderStates {
  nextOrderStates
}
    `;
 const OfferByIdDocument = gql`
    query OfferById($offerId: ID!) {
  offerById(offerId: $offerId) {
    id
    number
    date
    address
    subject
    headerText
    footerText
    termsOfDelivery
    termsOfPayment
    reference
    status
    additionalDiscount
    customOfferLines {
      id
      name
      price
      quantity
      taxRate
      discount
      positionTotal
      alternative
      productVariant {
        price
      }
    }
    company {
      id
      name
      customFields {
        erpId
        vat
        ust
      }
      addresses {
        streetLine1
        streetLine2
        province
        countryCode
        city
        postalCode
        phoneNumber
        defaultBillingAddress
      }
    }
    order {
      id
      totalWithTax
      lines {
        id
        customFields {
          offerOrderLine {
            id
            price
            quantity
            taxRate
            discount
            name
            alternative
            positionTotal
            productVariant {
              id
              price
              sku
              product {
                description
              }
              options {
                id
                name
                code
                group {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
 const OfferPositionVariantsDocument = gql`
    query OfferPositionVariants($skus: [String!]!) {
  variants(skus: $skus) {
    id
    name
    sku
    price
    options {
      id
      code
      name
      group {
        name
      }
    }
  }
}
    `;
 const OfferPriceDocument = gql`
    query offerPrice($productVariantId: ID!) {
  offerPrices(productVariantId: $productVariantId) {
    items {
      id
      price
      currencyCode
    }
  }
}
    `;
 const OfferPricesDocument = gql`
    query OfferPrices($take: Int, $skip: Int) {
  offerPrices(options: {take: $take, skip: $skip}) {
    totalItems
    items {
      ...OfferPrice
    }
  }
}
    ${OfferPriceFragmentDoc}
${AssetFragmentDoc}`;
 const OfferSettingsDocument = gql`
    query OfferSettings {
  offerSettings {
    id
    logo
    color
    vat
    iban
    accountNumber
    bankName
    bankCode
    address
    phoneNumber
    email
    companyRegister
  }
}
    `;
 const LatestOfferDocument = gql`
    query LatestOffer {
  offers(options: {sort: {number: DESC}, take: 1, skip: 0}) {
    id
    reference
    status
    createdAt
    number
    date
    address
    subject
    headerText
    footerText
    termsOfDelivery
    termsOfPayment
    order {
      lines {
        customFields {
          offerOrderLine {
            id
          }
        }
      }
    }
  }
}
    `;
 const OffersDocument = gql`
    query Offers($filter: OfferFilterOptions, $sort: OfferSortOptions, $take: Int, $skip: Int) {
  offers(options: {filter: $filter, sort: $sort, take: $take, skip: $skip}) {
    ...OfferFragment
  }
}
    ${OfferFragmentFragmentDoc}`;
 const OrderDocument = gql`
    query Order($code: String!) {
  orderByCode(code: $code) {
    id
    customer {
      id
      firstName
      lastName
      phoneNumber
    }
    code
    state
    active
    currencyCode
    shipping
    shippingAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      province
      postalCode
      country
      countryCode
      phoneNumber
      customFields
    }
    billingAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      province
      postalCode
      country
      countryCode
      phoneNumber
      customFields
    }
    shippingLines {
      shippingMethod {
        id
        languageCode
        code
        name
        description
      }
    }
    lines {
      id
      linePrice
      discountedLinePrice
      unitPrice
      quantity
      productVariant {
        currencyCode
        id
        name
        sku
        price
        product {
          id
          name
          slug
        }
        assets {
          id
          source
        }
        customFields {
          systemName
        }
      }
    }
    payments {
      method
    }
  }
}
    `;
 const PriceDocument = gql`
    query price($variantId: Int!) {
  pimcoreObjects(ids: [$variantId]) {
    productVariants {
      price
    }
  }
}
    `;
 const ProductDocument = gql`
    query Product($slug: String, $withCustomFields: Boolean = false, $isPreRender: Boolean = true) {
  product(slug: $slug) {
    id
    slug
    name
    description
    customFields {
      productDetailName
      infoText
      pimcoreId
    }
    assets {
      ...Asset
    }
    collections {
      id
      customFields {
        preselectedDiameter
      }
      breadcrumbs {
        ...Breadcrumb
      }
    }
    variants {
      ...ProductVariant
    }
    customFields {
      downloads {
        id
        fileName
        fileSize
        path
      }
    }
  }
}
    ${AssetFragmentDoc}
${BreadcrumbFragmentDoc}
${ProductVariantFragmentDoc}
${ProductVariantCustomFieldFragmentDoc}`;
 const ProductsDocument = gql`
    query Products($skip: Int) {
  products(options: {take: 20, skip: $skip}) {
    items {
      slug
      variants {
        id
      }
    }
  }
}
    `;
 const SearchDocument = gql`
    query Search($input: String!, $prefixMode: Boolean = true) {
  search(input: {term: $input, prefixMode: $prefixMode}) {
    items {
      id
      price {
        ... on SinglePrice {
          value
        }
      }
      productVariantAsset {
        preview
      }
      sku
      slug
      productId
      productName
      productVariantId
      productVariantName
      description
      customMappings {
        systemLine
        systemName
      }
    }
  }
}
    `;
 const VariantDocument = gql`
    query Variant($id: ID!, $withCustomFields: Boolean = false, $isPreRender: Boolean = true) {
  variant(variantId: $id) {
    ...ProductVariant
  }
}
    ${ProductVariantFragmentDoc}
${ProductVariantCustomFieldFragmentDoc}
${AssetFragmentDoc}`;
 const VariantAdditionalProductsDocument = gql`
    query VariantAdditionalProducts($variantId: ID!) {
  variantAdditionalProducts(variantId: $variantId) {
    id
    slug
    name
    featuredAsset {
      source
    }
    customFields {
      systemName
    }
  }
}
    `;
 const VariantDetailsDocument = gql`
    query VariantDetails($id: ID!, $includeImages: Boolean = false, $includeSystemInformation: Boolean = false, $includeDownloads: Boolean = false, $includeAdditionalProducts: Boolean = false) {
  variant(variantId: $id) {
    customFields {
      onSiteImages @include(if: $includeImages) {
        name
        source
      }
      onSiteImages @include(if: $includeImages) {
        name
        source
      }
      systemInformationItems @include(if: $includeSystemInformation) {
        itemText
        itemHeadline
      }
      downloads @include(if: $includeDownloads) {
        id
        fileName
        fileSize
        path
      }
      additionalProducts @include(if: $includeAdditionalProducts) {
        id
        slug
        featuredAsset {
          source
        }
        name
        customFields {
          systemName
        }
      }
    }
  }
}
    `;
 const VariantVendureIdDocument = gql`
    query variantVendureId($variantId: Int!) {
  pimcoreObjects(ids: [$variantId]) {
    productVariants {
      id
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AddItemToOrder(variables: Types.AddItemToOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AddItemToOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddItemToOrderMutation>({ document: AddItemToOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddItemToOrder', 'mutation', variables);
    },
    addItemToOrderBySku(variables: Types.AddItemToOrderBySkuMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AddItemToOrderBySkuMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddItemToOrderBySkuMutation>({ document: AddItemToOrderBySkuDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'addItemToOrderBySku', 'mutation', variables);
    },
    AddPayment(variables: Types.AddPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AddPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddPaymentMutation>({ document: AddPaymentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddPayment', 'mutation', variables);
    },
    AddToWishlist(variables: Types.AddToWishlistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AddToWishlistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddToWishlistMutation>({ document: AddToWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddToWishlist', 'mutation', variables);
    },
    UpdateCompanyAddress(variables: Types.UpdateCompanyAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateCompanyAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateCompanyAddressMutation>({ document: UpdateCompanyAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCompanyAddress', 'mutation', variables);
    },
    DeleteCompanyAddress(variables: Types.DeleteCompanyAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.DeleteCompanyAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteCompanyAddressMutation>({ document: DeleteCompanyAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCompanyAddress', 'mutation', variables);
    },
    CreateCompanyAddress(variables: Types.CreateCompanyAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateCompanyAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateCompanyAddressMutation>({ document: CreateCompanyAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCompanyAddress', 'mutation', variables);
    },
    AdjustOrderLine(variables: Types.AdjustOrderLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AdjustOrderLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AdjustOrderLineMutation>({ document: AdjustOrderLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdjustOrderLine', 'mutation', variables);
    },
    ApplyCouponCode(variables: Types.ApplyCouponCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ApplyCouponCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ApplyCouponCodeMutation>({ document: ApplyCouponCodeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ApplyCouponCode', 'mutation', variables);
    },
    CreateAddress(variables: Types.CreateAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateAddressMutation>({ document: CreateAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAddress', 'mutation', variables);
    },
    CreateAsset(variables: Types.CreateAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateAssetMutation>({ document: CreateAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAsset', 'mutation', variables);
    },
    createCustomerAddress(variables: Types.CreateCustomerAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateCustomerAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateCustomerAddressMutation>({ document: CreateCustomerAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createCustomerAddress', 'mutation', variables);
    },
    CreateOffer(variables: Types.CreateOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOfferMutation>({ document: CreateOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateOffer', 'mutation', variables);
    },
    CreateWishlist(variables: Types.CreateWishlistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateWishlistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateWishlistMutation>({ document: CreateWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateWishlist', 'mutation', variables);
    },
    DeleteOffer(variables: Types.DeleteOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.DeleteOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteOfferMutation>({ document: DeleteOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteOffer', 'mutation', variables);
    },
    DeleteWishlist(variables: Types.DeleteWishlistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.DeleteWishlistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteWishlistMutation>({ document: DeleteWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteWishlist', 'mutation', variables);
    },
    LoginUser(variables: Types.LoginUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.LoginUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LoginUserMutation>({ document: LoginUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LoginUser', 'mutation', variables);
    },
    LogoutUser(variables?: Types.LogoutUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.LogoutUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LogoutUserMutation>({ document: LogoutUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LogoutUser', 'mutation', variables);
    },
    SubscribeToNewsletter(variables: Types.SubscribeToNewsletterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SubscribeToNewsletterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SubscribeToNewsletterMutation>({ document: SubscribeToNewsletterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubscribeToNewsletter', 'mutation', variables);
    },
    UnsubscribeToNewsletter(variables: Types.UnsubscribeToNewsletterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UnsubscribeToNewsletterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnsubscribeToNewsletterMutation>({ document: UnsubscribeToNewsletterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnsubscribeToNewsletter', 'mutation', variables);
    },
    CreateOfferPrice(variables: Types.CreateOfferPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateOfferPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOfferPriceMutation>({ document: CreateOfferPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateOfferPrice', 'mutation', variables);
    },
    UpdateOfferPrice(variables: Types.UpdateOfferPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateOfferPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateOfferPriceMutation>({ document: UpdateOfferPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOfferPrice', 'mutation', variables);
    },
    DeleteOfferPrice(variables: Types.DeleteOfferPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.DeleteOfferPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteOfferPriceMutation>({ document: DeleteOfferPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteOfferPrice', 'mutation', variables);
    },
    CreateOfferPrices(variables: Types.CreateOfferPricesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateOfferPricesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateOfferPricesMutation>({ document: CreateOfferPricesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateOfferPrices', 'mutation', variables);
    },
    PasswordReset(variables: Types.PasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.PasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.PasswordResetMutation>({ document: PasswordResetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PasswordReset', 'mutation', variables);
    },
    Register(variables: Types.RegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RegisterMutation>({ document: RegisterDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Register', 'mutation', variables);
    },
    RemoveAllOrderLines(variables?: Types.RemoveAllOrderLinesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveAllOrderLinesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveAllOrderLinesMutation>({ document: RemoveAllOrderLinesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveAllOrderLines', 'mutation', variables);
    },
    removeAllOrderLinesAndStockMovements(variables?: Types.RemoveAllOrderLinesAndStockMovementsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveAllOrderLinesAndStockMovementsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveAllOrderLinesAndStockMovementsMutation>({ document: RemoveAllOrderLinesAndStockMovementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'removeAllOrderLinesAndStockMovements', 'mutation', variables);
    },
    RemoveCouponCode(variables: Types.RemoveCouponCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveCouponCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveCouponCodeMutation>({ document: RemoveCouponCodeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveCouponCode', 'mutation', variables);
    },
    RemoveFromWishlist(variables: Types.RemoveFromWishlistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveFromWishlistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveFromWishlistMutation>({ document: RemoveFromWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveFromWishlist', 'mutation', variables);
    },
    RemoveItemFromOrder(variables: Types.RemoveItemFromOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveItemFromOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveItemFromOrderMutation>({ document: RemoveItemFromOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveItemFromOrder', 'mutation', variables);
    },
    RequestPasswordReset(variables: Types.RequestPasswordResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RequestPasswordResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RequestPasswordResetMutation>({ document: RequestPasswordResetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RequestPasswordReset', 'mutation', variables);
    },
    SetActiveCompany(variables: Types.SetActiveCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SetActiveCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetActiveCompanyMutation>({ document: SetActiveCompanyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetActiveCompany', 'mutation', variables);
    },
    SetShippingAddress(variables: Types.SetShippingAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SetShippingAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetShippingAddressMutation>({ document: SetShippingAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetShippingAddress', 'mutation', variables);
    },
    SetBillingAddress(variables: Types.SetBillingAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SetBillingAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetBillingAddressMutation>({ document: SetBillingAddressDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetBillingAddress', 'mutation', variables);
    },
    SetOrderCustomFields(variables?: Types.SetOrderCustomFieldsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SetOrderCustomFieldsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetOrderCustomFieldsMutation>({ document: SetOrderCustomFieldsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetOrderCustomFields', 'mutation', variables);
    },
    SetOrderShippingMethod(variables: Types.SetOrderShippingMethodMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SetOrderShippingMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SetOrderShippingMethodMutation>({ document: SetOrderShippingMethodDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetOrderShippingMethod', 'mutation', variables);
    },
    ToogleCustomerSpecificPrice(variables?: Types.ToogleCustomerSpecificPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ToogleCustomerSpecificPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ToogleCustomerSpecificPriceMutation>({ document: ToogleCustomerSpecificPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ToogleCustomerSpecificPrice', 'mutation', variables);
    },
    transformOfferToCart(variables: Types.TransformOfferToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.TransformOfferToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TransformOfferToCartMutation>({ document: TransformOfferToCartDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'transformOfferToCart', 'mutation', variables);
    },
    TransitionOrder(variables: Types.TransitionOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.TransitionOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TransitionOrderMutation>({ document: TransitionOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TransitionOrder', 'mutation', variables);
    },
    UpdateCustomer(variables: Types.UpdateCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateCustomerMutation>({ document: UpdateCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomer', 'mutation', variables);
    },
    UpdateCustomerPassword(variables: Types.UpdateCustomerPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateCustomerPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateCustomerPasswordMutation>({ document: UpdateCustomerPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomerPassword', 'mutation', variables);
    },
    RequestUpdateCustomerEmail(variables: Types.RequestUpdateCustomerEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RequestUpdateCustomerEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RequestUpdateCustomerEmailMutation>({ document: RequestUpdateCustomerEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RequestUpdateCustomerEmail', 'mutation', variables);
    },
    UpdateOffer(variables: Types.UpdateOfferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateOfferMutation>({ document: UpdateOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOffer', 'mutation', variables);
    },
    UpdateOfferSettings(variables?: Types.UpdateOfferSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateOfferSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateOfferSettingsMutation>({ document: UpdateOfferSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOfferSettings', 'mutation', variables);
    },
    UpdateWishlist(variables: Types.UpdateWishlistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateWishlistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateWishlistMutation>({ document: UpdateWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateWishlist', 'mutation', variables);
    },
    ActiveChannel(variables?: Types.ActiveChannelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveChannelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveChannelQuery>({ document: ActiveChannelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveChannel', 'query', variables);
    },
    ActiveCompany(variables?: Types.ActiveCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCompanyQuery>({ document: ActiveCompanyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCompany', 'query', variables);
    },
    ActiveCompanyAddresses(variables?: Types.ActiveCompanyAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCompanyAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCompanyAddressesQuery>({ document: ActiveCompanyAddressesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCompanyAddresses', 'query', variables);
    },
    ContactPersonId(variables?: Types.ContactPersonIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ContactPersonIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ContactPersonIdQuery>({ document: ContactPersonIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ContactPersonId', 'query', variables);
    },
    ActiveCustomer(variables?: Types.ActiveCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCustomerQuery>({ document: ActiveCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCustomer', 'query', variables);
    },
    ActiveCustomerRoles(variables?: Types.ActiveCustomerRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCustomerRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCustomerRolesQuery>({ document: ActiveCustomerRolesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCustomerRoles', 'query', variables);
    },
    ActiveCustomerForCheckout(variables?: Types.ActiveCustomerForCheckoutQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCustomerForCheckoutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCustomerForCheckoutQuery>({ document: ActiveCustomerForCheckoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCustomerForCheckout', 'query', variables);
    },
    ActiveCustomerOrders(variables?: Types.ActiveCustomerOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCustomerOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCustomerOrdersQuery>({ document: ActiveCustomerOrdersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCustomerOrders', 'query', variables);
    },
    ActiveOrderCart(variables?: Types.ActiveOrderCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveOrderCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveOrderCartQuery>({ document: ActiveOrderCartDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveOrderCart', 'query', variables);
    },
    ActiveOrderCheckout(variables?: Types.ActiveOrderCheckoutQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveOrderCheckoutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveOrderCheckoutQuery>({ document: ActiveOrderCheckoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveOrderCheckout', 'query', variables);
    },
    ActiveOrderNavigation(variables?: Types.ActiveOrderNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveOrderNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveOrderNavigationQuery>({ document: ActiveOrderNavigationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveOrderNavigation', 'query', variables);
    },
    ActiveOrderOffer(variables?: Types.ActiveOrderOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveOrderOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveOrderOfferQuery>({ document: ActiveOrderOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveOrderOffer', 'query', variables);
    },
    ActiveUserWishlist(variables: Types.ActiveUserWishlistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveUserWishlistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveUserWishlistQuery>({ document: ActiveUserWishlistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveUserWishlist', 'query', variables);
    },
    ActiveUserWishlists(variables?: Types.ActiveUserWishlistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveUserWishlistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveUserWishlistsQuery>({ document: ActiveUserWishlistsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveUserWishlists', 'query', variables);
    },
    AllCollections(variables?: Types.AllCollectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AllCollectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AllCollectionsQuery>({ document: AllCollectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AllCollections', 'query', variables);
    },
    AvailableCompanies(variables?: Types.AvailableCompaniesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AvailableCompaniesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AvailableCompaniesQuery>({ document: AvailableCompaniesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AvailableCompanies', 'query', variables);
    },
    AvailableCountries(variables?: Types.AvailableCountriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AvailableCountriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AvailableCountriesQuery>({ document: AvailableCountriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AvailableCountries', 'query', variables);
    },
    Collection(variables?: Types.CollectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CollectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CollectionQuery>({ document: CollectionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Collection', 'query', variables);
    },
    CustomerSpecificPrice(variables: Types.CustomerSpecificPriceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CustomerSpecificPriceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CustomerSpecificPriceQuery>({ document: CustomerSpecificPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CustomerSpecificPrice', 'query', variables);
    },
    EligiblePaymentMethods(variables?: Types.EligiblePaymentMethodsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.EligiblePaymentMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.EligiblePaymentMethodsQuery>({ document: EligiblePaymentMethodsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EligiblePaymentMethods', 'query', variables);
    },
    EligibleShippingMethods(variables?: Types.EligibleShippingMethodsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.EligibleShippingMethodsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.EligibleShippingMethodsQuery>({ document: EligibleShippingMethodsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EligibleShippingMethods', 'query', variables);
    },
    NextOrderStates(variables?: Types.NextOrderStatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.NextOrderStatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NextOrderStatesQuery>({ document: NextOrderStatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NextOrderStates', 'query', variables);
    },
    OfferById(variables: Types.OfferByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OfferByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OfferByIdQuery>({ document: OfferByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OfferById', 'query', variables);
    },
    OfferPositionVariants(variables: Types.OfferPositionVariantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OfferPositionVariantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OfferPositionVariantsQuery>({ document: OfferPositionVariantsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OfferPositionVariants', 'query', variables);
    },
    offerPrice(variables: Types.OfferPriceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OfferPriceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OfferPriceQuery>({ document: OfferPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'offerPrice', 'query', variables);
    },
    OfferPrices(variables?: Types.OfferPricesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OfferPricesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OfferPricesQuery>({ document: OfferPricesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OfferPrices', 'query', variables);
    },
    OfferSettings(variables?: Types.OfferSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OfferSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OfferSettingsQuery>({ document: OfferSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'OfferSettings', 'query', variables);
    },
    LatestOffer(variables?: Types.LatestOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.LatestOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LatestOfferQuery>({ document: LatestOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LatestOffer', 'query', variables);
    },
    Offers(variables?: Types.OffersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OffersQuery>({ document: OffersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Offers', 'query', variables);
    },
    Order(variables: Types.OrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.OrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrderQuery>({ document: OrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Order', 'query', variables);
    },
    price(variables: Types.PriceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.PriceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.PriceQuery>({ document: PriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'price', 'query', variables);
    },
    Product(variables?: Types.ProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ProductQuery>({ document: ProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Product', 'query', variables);
    },
    Products(variables?: Types.ProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ProductsQuery>({ document: ProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Products', 'query', variables);
    },
    Search(variables: Types.SearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SearchQuery>({ document: SearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Search', 'query', variables);
    },
    Variant(variables: Types.VariantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.VariantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.VariantQuery>({ document: VariantDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Variant', 'query', variables);
    },
    VariantAdditionalProducts(variables: Types.VariantAdditionalProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.VariantAdditionalProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.VariantAdditionalProductsQuery>({ document: VariantAdditionalProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VariantAdditionalProducts', 'query', variables);
    },
    VariantDetails(variables: Types.VariantDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.VariantDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.VariantDetailsQuery>({ document: VariantDetailsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VariantDetails', 'query', variables);
    },
    variantVendureId(variables: Types.VariantVendureIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.VariantVendureIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.VariantVendureIdQuery>({ document: VariantVendureIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'variantVendureId', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;